export const acceptedFilesExtensions = [
  '3dm',
  '3ds',
  'a',
  'asm',
  'brd',
  'catpart',
  'catproduct',
  'cgr',
  'collaboration',
  'dae',
  'dgn',
  'dlv3',
  'dwf',
  'dwfx',
  'dwg',
  'dwt',
  'dxf',
  'emode',
  'exp',
  'f2d',
  'f3d',
  'fbx',
  'g',
  'gbxml',
  'glb',
  'gltf',
  'iam',
  'idw',
  'ifc',
  'ige',
  'iges',
  'igs',
  'ipt',
  'iwm',
  'jt',
  'max',
  'model',
  'mpf',
  'msr',
  'neu',
  'neu',
  'nwc',
  'nwd',
  'par',
  'pmlprj',
  'pmlprjz',
  'prt',
  'prt',
  'psm',
  'psmodel',
  'rvt',
  'sab',
  'sat',
  'sch',
  'session',
  'skp',
  'sldasm',
  'sldprt',
  'ste',
  'step',
  'stl',
  'stla',
  'stlb',
  'stp',
  'stpz',
  'vue',
  'wire',
  'x_b',
  'x_t',
  'xas',
  'xpr',
]
